<template>
  <main class="password-recovery">
    <h1 class="password-recovery__title">Восстановление пароля</h1>
    <form v-on:submit.prevent="onSubmit" class="password-recovery__form">
      <p class="password-recovery__instruction">
        На указанный вами адрес электронной почты будет выслано письмо с ссылкой
        на создание нового пароля.
      </p>
      <label class="password-recovery__group">
        <span class="password-recovery__label">Введите адрес электронной почты</span>
        <input
          class="password-recovery__input"
          placeholder="account@example.com"
          required
          type="email"
          v-model="email" />
      </label>
      <button
        class="password-recovery__button"
        type="submit"
      >ОТПРАВИТЬ</button>
    </form>
    <div class="password-recovery__description">
      Есть данные для входа?
      <router-link
        :to="{ name: 'Auth', params: { initialEmail: email } }"
        class="">Войти</router-link>
    </div>
  </main>
</template>
<script>
import notifierMixin from '@/mixins/notifierMixin';
/**
 * @description Компонент восстановления пароля.
 * @type {Vue}
 */
export default {
  data() {
    return {
      /**
       * @description Адрес электронной почты.
       * @type {string}
       */
      email: '' || this.initialEmail,
    };
  },
  methods: {
    /**
     * @description Обработать отправку восстановления пароля.
     * @returns {void}
     */
    onSubmit() {
      this
        .$authGateway
        .sendPasswordRecoveryEmail(this.email)
        .then((result) => {
          result.forEach(({ message }) => {
            this.notifySuccess(message);
            this.$router.push({ name: 'Auth' });
          });
          result.forEachLeft(({ message }) => {
            this.notifyFail(message);
          });
        });
    },
  },
  mixins: [
    notifierMixin,
  ],
  props: {
    /**
     * @description Email пользователя
     * @type {String}
     */
    initialEmail: {
      default: '',
      type: String,
    },
  },
  name: 'ForgotPassword',
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
.password-recovery {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-width: 605px;
  width: 100%;
  &__description {
    color: var(--reading-color);
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 1.5rem;
    margin: 38px auto 0 0;
    a {
      text-decoration: none;
      font-weight: 500;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 50px;
    line-height: 60px;
    margin: 0 auto 10px 0;
  }
  &__form {
    display: flex;
    flex-direction: column;
  }
  &__label {
    color: #90A0B7;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
  &__input {
    border-radius: var(--input-border-radius);
    display: flex;
    flex-direction: column;
    border: 1px solid #C2CFE0;
    height: 57px;
    width: 100%;
    padding: 0 15px;
    color: #192A3E;
    opacity: 0.7;
    margin: 0 0 30px 0;
    &:focus {
      color: #192A3E;
      background-color: #fff;
      border: 2px solid #0489E0;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
  &__instruction {
    color: #000000;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    margin: 0 0 30px 0;
  }
  &__button {
    @include buttons.btn-blue(280px, 70px, 20px);
  }
}
@media screen and (max-width: 480px) {
  .password-recovery {
    &__title {
      font-size: 28px;
      line-height: 30px;
      margin: 0 auto 10px 0;
    }
    &__instruction {
      font-size: 14px;
      line-height: 18px;
      margin: 0 0 30px 0;
    }
  }
}
</style>
